import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const EditComponent = ({ history }) => {
  return (
    <div className={styles.mainComponent}>
      <button
        className={styles.button}
        onClick={() => history.push("/settings")}
      >
        Edit Profile
      </button>
    </div>
  );
};

EditComponent.propTypes = {
  history: PropTypes.object,
};

export default withRouter(EditComponent);
